module.exports = __webpack_public_path__ + "img/0Q3C0560_BlackMatted.559adc85.jpg";